<template>
  <page>
    <div>
      <v-flex xs12>
        <form>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xl4 lg4 xs4>
                          <v-text-field
                            v-model="filters.insLtarefNo"
                            :label="labels.insLtarefNo"
                            :error-messages="errors.collect('insLtarefNo')"
                            data-vv-name="insLtarefNo"
                            :data-vv-as="labels.insLtarefNo"
                            v-validate="'name|max:5'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xl4 lg4 xs4>
                          <v-text-field
                            v-model="filters.batchNo"
                            :label="labels.batchNo"
                            :error-messages="errors.collect('batchNo')"
                            data-vv-name="batchNo"
                            :data-vv-as="labels.batchNo"
                            v-validate="'max:10'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xl4 lg4 xs4>
                          <v-autocomplete
                            :items="branchList"
                            v-model="filters.defBranch"
                            :label="labels.defBranch"
                            item-text="label"
                            item-value="value"
                            data-vv-name="defBranch"
                            :data-vv-as="labels.defBranch"
                            :error-messages="errors.collect('defBranch')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-layout row wrap>
            <v-spacer></v-spacer>
            <div v-if="hideCreate">
              <v-btn color="primary" @click.native="doNew()"> New LTA Parameter<v-icon right>mdi-plus</v-icon> </v-btn>
            </div>
          </v-layout>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="items"
          v-bind:options.sync="pagination"
          :server-items-length="totalItems"
          :loading="loading"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.insLtarefNo }}</td>
              <td class="text-xs-left">{{ row.item.batchNo }}</td>
              <td class="text-xs-left">{{ formatDate(row.item.impLtadate) }}</td>
              <td class="text-xs-left">{{ formatDate(row.item.upldDate) }}</td>
              <td class="text-xs-left">{{ row.item.defBranch }}</td>
              <td class="table-action-header">
                <table-action
                  :rowData="row"
                  query
                  @query="doQuery(row.item.insLtarefNo)"
                  review
                  @review="doReview(row.item.insLtarefNo)"
                  remove
                  @remove="doPromptRemove(row.item)"
                ></table-action>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected LTA Paremeter? ({{ selectedLTAParam.insLtarefNo }})
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'

export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'Insurance Company LTA Ref No.', align: 'left', value: 'insLtarefNo' },
        { text: 'Batch No.', value: 'batchNo' },
        { text: 'Implementation Date', value: 'impLtadate' },
        { text: 'Last Upload Date', value: 'upldDate' },
        { text: 'Default Branch', value: 'defBranch' },
        TableConst.tableActionHeader
      ],
      labels: {
        insLtarefNo: 'Insurance Company LTA Ref no.',
        batchNo: 'Batch no.',
        defBranch: 'Default Branch'
      },
      filters: {
        insLtarefNo: undefined,
        batchNo: undefined,
        defBranch: undefined
      },
      branchList: [],
      totalItems: 0,
      selectedLTAParam: '',
      loading: false,
      promptRemove: false,
      hideCreate: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.uwMotorParam.menu
    }
  },
  methods: {
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.menu.getLTAParamPage
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            if (this.totalItems > 0) {
              this.hideCreate = false
            } else {
              this.hideCreate = true
            }
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((lta) => {
                const convertList = {
                  insLtarefNo: lta.insLtarefNo,
                  batchNo: lta.batchNo,
                  impLtadate: lta.impLtadate,
                  upldDate: lta.upldDate,
                  defBranch: lta.defBranch
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    async getBranchList() {
      const apiURI = this.menu.getBranchList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          data.map((brn) => {
            const convertList = {
              label: brn.branch + ' - ' + brn.brnDesc,
              value: brn.branch
            }
            this.branchList.push(convertList)
          })
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.insLtarefNo = null
      this.filters.batchNo = null
      this.filters.defBranch = null
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doReview(insLtarefNo) {
      this.$router.push({ name: 'ltaParamReview', params: { mode: 'edit', insLtarefNo: insLtarefNo } })
    },
    doQuery(insLtarefNo) {
      this.$router.push({ name: 'ltaParamReview', params: { mode: 'query', insLtarefNo: insLtarefNo } })
    },
    doNew() {
      this.$router.push({ name: 'ltaParamReview', params: { mode: 'new', insLtarefNo: 'new' } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedLTAParam = data
      }
    },
    async doRemove() {
      const apiURI = this.menu.deleteLTAParam
      if (apiURI) {
        const expand = this.selectedLTAParam
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(true)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  mounted() {
    this.doInit(true)
    this.getBranchList()
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
